export * as Icon from './icons';
export {
  iconSizes,
  type IconSize,
  type IconTypes,
  type IconProps,
  IconBase,
} from './iconBase';
export { type IconName, DynamicIcon, ICON_NAMES } from './iconLookup';
export { flags } from './flag';
